// import request from '@/utils/request'
import axios from 'axios'
let request = ({ url, method = 'post', data = {} }) => {
  let headers = {}
  let jwt = window.localStorage.getItem('teacher-jwt')
  // let uid = window.localStorage.getItem('teacher-uid')
  headers['Authorization'] = `bearer ${jwt}`
  return axios({
    // baseURL: process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : 'https://yoteach-cloud.herokuapp.com',
    baseURL: 'https://yoteach-cloud.herokuapp.com',
    url,
    headers,
    method,
    data
  })
}

export function loginByUsernameCrypt({ auth }) {
  const data = {
    auth
  }
  return request({
    url: '/jwt/login-crypt',
    method: 'post',
    data
  })
}

export function loginByUsername(username, password) {
  const data = {
    username,
    password
  }
  return request({
    url: '/jwt/login',
    method: 'post',
    data
  })
}

export function registerByUsername(username, password) {
  const data = {
    username,
    password
  }

  return request({
    url: '/jwt/register',
    method: 'post',
    data
  })
}

export function logout() {
  return request({
    url: '/logout',
    method: 'post'
  })
}

export function getUserInfo(token) {
  return request({
    url: '/jwt/myself',
    method: 'get'// ,
    // params: { token }
  })
}

export function checkValidUsername(name) {
  return request({
    url: '/checkValidUsername/' + name,
    method: 'get'
  })
}

export function checkUniqueUsername(name) {
  return request({
    url: '/checkUniqueUsername/' + name,
    method: 'get'
  })
}

export function activateAdminRole(data) {
  return request({
    url: '/activateAdminRole',
    method: 'post',
    data
  })
}

// checkValidUsername('wonglok831')
